import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// The prerendered HTML carries the page's title, description, canonical and OG
// tags so the crawler's first fetch has them. Under React 19 those tags are
// hoisted natively, so react-helmet-async adds its own copies instead of
// replacing the static ones and the page ends up with two of each. Every
// static SEO tag is marked data-rh at build time; nothing else has rendered
// yet, so dropping them here leaves Helmet as the single source of truth.
document.head.querySelectorAll('[data-rh]').forEach((el) => el.remove());

// scripts/prerender.js writes crawlable HTML into #root at build time so the
// first fetch of every URL carries real content. That markup is authored for
// crawlers, not produced by React, so hydrating it would mismatch on every
// node. createRoot clears the container and renders the app fresh instead.
ReactDOM.createRoot(rootElement).render(app);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
